'use client';

import { createContext, useContext, type ReactNode } from 'react';
import { useSaleLotNavigation } from '@/hooks/publicSearch/sale-catalogue/useSaleLotNavigation';

type SaleLotCatalogueContextValue = {
  navigation: ReturnType<typeof useSaleLotNavigation>;
};

const SaleLotCatalogueContext =
  createContext<SaleLotCatalogueContextValue | null>(null);

/**
 * Owns sale-lot navigation only when an animal detail page is opened from a
 * catalogue. Keeps useSaleLotNavigation off ordinary animal-detail mounts.
 */
export function SaleLotCatalogueProvider({
  saleId,
  lotNo,
  animalId,
  children,
}: {
  saleId: string;
  lotNo: string;
  animalId: string;
  children: ReactNode;
}) {
  const navigation = useSaleLotNavigation({ saleId, lotNo, animalId });

  return (
    <SaleLotCatalogueContext.Provider value={{ navigation }}>
      {children}
    </SaleLotCatalogueContext.Provider>
  );
}

export function useSaleLotCatalogueContext(): SaleLotCatalogueContextValue | null {
  return useContext(SaleLotCatalogueContext);
}
